import {
    GET_TRANSACTION_SOURCE_DEF,
    GET_TRANSACTION_SOURCE_DEF_SUCCESS,
    TRANSACTION_SOURCE_DEF_API_ERROR
} from "./actionTypes"

export const getTransactionSourceDefList = () => ({
    type: GET_TRANSACTION_SOURCE_DEF,
})

export const getTransactionSourceDefListSuccess = record => ({
    type: GET_TRANSACTION_SOURCE_DEF_SUCCESS,
    payload: record,
})

export const transactionSourceDefApiError = error => {
    return {
        type: TRANSACTION_SOURCE_DEF_API_ERROR,
        payload: error,
    }
}
